<template>
    <div class="layout-content">
        <global-header
            :school="1"
            :title="'학교 방문예약'"
        />
        <div class="unused">
            학교 방문예약시스템을 사용하지 않는 학교입니다.
        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { store } from "@/store";

export default {
    name: 'UnusedSchool',
    components: { GlobalHeader },
    data: () => ({
        store,
    }),
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.replace({ path: `/schools/${this.$route.params.school}/visit` });
        }
    },
}
</script>

<style lang='scss'>
.unused {
    padding: 20vh 0;
    text-align: center;
}
</style>
